module.exports = __webpack_public_path__ + "static/media/2loop1.a5a22ccb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/2loop1.jpg
// module id = 286
// module chunks = 0